module.exports = __webpack_public_path__ + "static/media/map-background.97615300.ogg";